import { Component, OnInit, OnDestroy, ViewEncapsulation, ChangeDetectionStrategy, Input, ChangeDetectorRef, Renderer2, ElementRef } from '@angular/core';
import { f3Animations } from '@f3/animations';
import { Subject, takeUntil } from 'rxjs';
import { CasualHireFormService } from '../casual-hire-form.service';
import * as _ from 'lodash-es';
import { CustomPipesModule } from '../../../../../../../@f3/pipes/custom-pipes.module';
import { HireFormNavigationButtonComponent } from '../navigation-button/navigation-button.component';
import { NgClass, CurrencyPipe } from '@angular/common';

@Component({
    selector: 'hire-form-order-summary',
    templateUrl: './order-summary.component.html',
    styleUrls: ['./order-summary.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: f3Animations,
    standalone: true,
    imports: [NgClass, HireFormNavigationButtonComponent, CurrencyPipe, CustomPipesModule]
})
export class HireFormOrderSummaryComponent implements OnInit, OnDestroy {

	@Input() public showOrderSummary: boolean = false;

	// @Public Properties
	public orderData: any = null

	public displayNavButton: boolean = false;

	// @Private Properties
	private _unsubscribeAll: Subject<any> = new Subject;

	private _scrollWatcher!: () => void;

	/**
	* Constructor
	*/
	constructor(
		private _renderer2: Renderer2,
		private _elementRef: ElementRef,
		private _changeDetectorRef: ChangeDetectorRef,
		private _casualHireFormService: CasualHireFormService
	) { }


	//--------------------------------------------------------------------------------
	// @Lifecycle Hooks
	//--------------------------------------------------------------------------------

	/**
	* OnInit
	*/
	ngOnInit(): void {

		this._casualHireFormService.orderData$.pipe(
			takeUntil(this._unsubscribeAll)
		).subscribe({
			next: (orderData) => {
				this.orderData = orderData

				this._changeDetectorRef.markForCheck()
			}
		})
	}

	/**
	 * 
	 */
	ngAfterViewInit() {

		this._scrollWatcher = this._renderer2.listen('window', 'scroll', event => {
			this.displayNavButton = this._elementRef.nativeElement.getBoundingClientRect().y < 155 ? true : false;
			this._changeDetectorRef.markForCheck()
		})
	}

	/**
	* OnDestroy
	*/
	ngOnDestroy() {
		if(this._scrollWatcher) {
			this._scrollWatcher()
		}

		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}


	//--------------------------------------------------------------------------------
	// @Accessors
	//--------------------------------------------------------------------------------

	get orderTotal() {
		if(!this.orderData?.regalia?.length) {
			return 0;
		}

		return _.sumBy(this.orderData.regalia, (r: any) => r?.price ?? 0)
	}

	get orderCurrency() {
		if(!this.orderData?.regalia?.length) {
			return 'NZD';
		}

		const withCurrency = this.orderData.regalia.find((item: any) => item?.currency);
		return withCurrency?.currency || 'NZD';
	}

	//--------------------------------------------------------------------------------
	// @Public Methods
	//--------------------------------------------------------------------------------

	public getCurrentStep() {
		return this._casualHireFormService.getCurrentStep()
	}


}
